import { render, staticRenderFns } from "./NotificationsButton.vue?vue&type=template&id=f400a9de&scoped=true&"
import script from "./NotificationsButton.vue?vue&type=script&lang=ts&"
export * from "./NotificationsButton.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsButton.vue?vue&type=style&index=0&id=f400a9de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f400a9de",
  null
  
)

export default component.exports